<template>
    <label class="mb-0">
        <slot name="labelText">{{ 'Credits' | trans }}:<br /></slot>
        <select class="bg-white px-2 py-1 mt-2" v-model="selectedConversionMinutes" :disabled="disabled">
            <option v-for="(minutes, label) in selectableConversionMinutes" :value="minutes">{{ label }}</option>
        </select>
    </label>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    name: 'SelectConversionMinutesDropdown',
    mixins: [TransFilter],
    props: {
        selectableConversionMinutes: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '500',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        selectedConversionMinutes(minutes, oldMinutes) {
            if (minutes === oldMinutes) {
                // no need to emit event if the value didn't change
                return;
            }

            this.$emit('input', minutes);
        },
    },
    data() {
        return {
            selectedConversionMinutes: this.value,
        };
    },
};
</script>
